import { generateURL } from 'utils/helpers';

const vehicleLink = {
  segments: () => {
    const url = generateURL('/vehiclelink/segments');

    return fetch(url).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to fetch segments'));
      }
      return response.json();
    });
  },

  makes: (code) => {
    const url = generateURL(`/vehiclelink/segments/${code}/makes`);

    return fetch(url).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to fetch makes'));
      }
      return response.json();
    });
  },

  families: ({ code, makeCode }) => {
    const url = generateURL(
      `/vehiclelink/segments/${code}/families?make_code=${makeCode}`
    );

    return fetch(url).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to fetch families'));
      }
      return response.json();
    });
  },

  vehicles: ({ code, makeCode, familyCode, bodyStyleCode, sizeUnit = 'm' }) => {
    const url = generateURL(
      `/vehiclelink/segments/${code}/vehicles?make_code=${makeCode}&family_code=${familyCode}&body_style_code=${bodyStyleCode}&size_unit=${sizeUnit}`
    );

    return fetch(url).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to fetch vehicles'));
      }

      return response.json();
    });
  },

  variants: ({
    code,
    makeCode,
    familyCode,
    bodyStyleCode,
    yearCode,
    sizeUnit = 'm',
  }) => {
    const url = generateURL(
      `/vehiclelink/segments/${code}/variants?make_code=${makeCode}&family_code=${familyCode}&body_style_code=${bodyStyleCode}&year_code=${yearCode}&size_unit=${sizeUnit}`
    );

    return fetch(url).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to fetch variants'));
      }

      return response.json();
    });
  },

  attachments: () => {
    const url = generateURL('/vehiclelink/attachments');

    return fetch(url).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to fetch attachments'));
      }
      return response.json();
    });
  },
};

export default vehicleLink;
